module.exports = __webpack_public_path__ + "img/cardImg.31a1b27b.png";